module.exports = __webpack_public_path__ + "img/html-evolution-13.f7cdd0c2.webp";